<template>
  <div id="topic-management-detail">
    <!-- begin page-header -->
    <h1 class="page-header">
      <img :src="renderPicture(subject.picture)" style="max-width: 80px; margin-right: 10px">
      <router-link :to="{path: '/topic-management/detail', query: { subject_id: subject.id}}">{{subject.nama}}</router-link>
      <span v-if="topic"> &rarr;
        <router-link :to="{path: '/topic-management/detail', query: { subject_id: subject.id, topic_id: topic.id}}">{{topic.nama}}</router-link>
      </span>
      <span v-if="subTopic"> &rarr;
        <router-link :to="{path: '/topic-management/detail', query: { subject_id: subject.id, topic_id: topic.id, sub_topic_id: subTopic.id}}">{{subTopic.nama}}</router-link>
      </span>
      <span v-if="subSubTopic">{{subSubTopic.nama}}</span>
    </h1>
    <div class="row">
      <div class="input-group m-b-10 col-md-10">
        <input type="text" class="form-control" placeholder="Masukan kata kunci pencarian ..." v-model="searchQuery">
        <span class="input-group-addon"><i class="fa fa-search"></i></span>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success btn-block" @click="showNewTopicDialog=true"><i class="fa fa-plus"></i> Topik</button>
      </div>
    </div>
    <!-- end page-header -->

    <div class="row">
      <h4 v-if="cards.length == 0" style="margin-left: 30%">Tidak ada data untuk kategori ini ...</h4>
      <div class="col-md-4 col-sm-12" v-for="card in filteredCards" v-bind:key="card.id">
        <div class="card-header" style="text-align: right; padding: 5px">
          <a href="javascript:;" class="btn btn btn-icon btn-primary" @click="showDetail(card)"><i class="fa fa-edit"></i></a>
          <a href="javascript:;" class="btn btn btn-icon btn-danger" @click="showDeleteConfirmation(card)"><i class="fa fa-trash"></i></a>
        </div>
        <div class="widget widget-stats" v-bind:class="bgColor(card.id)">
          <div class="stats-icon"><img :src="renderPicture(card.picture)" alt="subject-logo" style="max-width: 80px"></div>
          <div class="stats-info">
            <h4>Kode: {{card.kode}}</h4>
            <p>{{truncateText(card.nama, 20)}}</p>
          </div>
          <div class="stats-link" v-if="!topic">
            <router-link :to="{path: '/topic-management/detail', query: { subject_id: subject.id, topic_id: card.id }}">Lihat Sub Bab <i class="fa fa-arrow-circle-o-right"></i></router-link>
          </div>
          <div class="stats-link" v-if="topic && !subTopic">
            <router-link :to="{path: '/topic-management/detail', query: { subject_id: subject.id, topic_id: topic.id, sub_topic_id: card.id }}">Lihat Sub Sub Bab <i class="fa fa-arrow-circle-o-right"></i></router-link>
          </div>
        </div>
      </div>
    </div>
    <app-modal v-if="showNewTopicDialog" :withCancel="true" v-on:cancel="showNewTopicDialog=false; errors = []" v-on:ok="addNewTopic()">
      <h3 slot="header">Tambah Topik Baru</h3>
      <form slot="body" class="form-horizontal">
        <div class="form-group">
          <label for="topic_parent" class="col-md-3 control-label">Induk</label>
          <div class="col-md-9">
            <input type="text" class="form-control" :value="topicParentName" readonly/>
          </div>
        </div>
        <div class="form-group" v-bind:class="{'has-error': errors.formTopicName, 'has-feedback': errors.formTopicName}">
          <label for="topic_parent" class="col-md-3 control-label">Nama *</label>
          <div class="col-md-9">
            <input type="text" class="form-control" v-model="formTopicName" required/>
          </div>
        </div>
      </form>
    </app-modal>
    <app-modal :withCancel="true" v-if="showConfirmationModal" v-on:cancel="showConfirmationModal=false" v-on:ok="deleteTopic()">
      <h3 slot="header">Konfirmasi</h3>
      <div slot="body">Apakah ada yakin akan menghapus topik <strong style="color: red">{{selectedTopic.name}} ?</strong></div>
    </app-modal>
    <app-modal v-if="showModal" :withCancel="true" v-on:cancel="showModal = false" v-on:ok="updateTopic()">
      <h3 slot="header">Topic Detail</h3>
      <form slot="body" class="form-horizontal">
        <div class="form-group">
          <label for="topic_parent" class="col-md-3 control-label">Induk</label>
          <div class="col-md-9">
            <input type="text" class="form-control" :value="selectedTopic.parentName" readonly/>
          </div>
        </div>
        <div class="form-group">
          <label for="topic_code" class="col-md-3 control-label">Kode</label>
          <div class="col-md-9">
            <input type="text" class="form-control" :value="selectedTopic.code" readonly/>
          </div>
        </div>
        <div class="form-group" v-bind:class="{'has-error': errors.formTopicName, 'has-feedback': errors.formTopicName}">
          <label for="topic_name" class="col-md-3 control-label">Nama</label>
          <div class="col-md-9">
            <input type="text" class="form-control" v-model="selectedTopic.name" />
          </div>
        </div>
      </form>
    </app-modal>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import ItembankService from '@/services/itembank.js'
import Modal from '@/components/plugins/Modal'
import Spinner from '@/components/plugins/Spinner'

export default {
  name: 'topic-management-detail',
  data: function () {
    return {
      subject: null,
      topic: null,
      subTopic: null,
      subSubTopic: null,
      cards: [],
      filteredCards: [],
      topics: [],
      bgColors: ['bg-green', 'bg-blue', 'bg-purple', 'bg-red'],
      searchQuery: '',
      showModal: false,
      showConfirmationModal: false,
      selectedTopic: null,
      isLoading: false,
      formTopicName: '',
      showNewTopicDialog: false,
      errors: []
    }
  },
  components: {
    'app-modal': Modal,
    'app-spinner': Spinner
  },
  watch: {
    '$route.query.topic_id': function (val) {
      var context = this
      context.searchQuery = ''

      if (!val) {
        context.topic = null
        context.cards = context.topics
        context.filteredCards = context.cards
      } else {
        var topicId = parseInt(val)
        var found = context.cards.find(function (card) {
          return card.id === topicId
        })

        context.topic = found
        context.cards = context.topic.subs
        context.filteredCards = context.cards
      }
    },
    '$route.query.sub_topic_id': function (val) {
      var context = this
      context.searchQuery = ''

      if (!val) {
        context.subTopic = null
        if (context.topic) {
          context.cards = context.topic.subs
          context.filteredCards = context.cards
        }
      } else {
        var subTopicId = parseInt(val)
        var found = context.cards.find(function (card) {
          return card.id === subTopicId
        })

        context.subTopic = found
        context.cards = context.subTopic.subs
        context.filteredCards = context.cards
      }
    },
    searchQuery: function (val) {
      if (val.length === 0) this.filteredCards = this.cards
      if (val.length < 3) return;

      this.filteredCards = this.cards.filter(function (card) {
        return card.nama.toLowerCase().includes(val.toLowerCase())
      })
    }
  },
  computed: {
    topicParentName: function () {
      if (this.topic) return this.topic.nama
      if (this.subTopic) return this.subTopic.nama

      return this.subject.nama
    }
  },
  methods: {
    bgColor: function (id) {
      var index = id % 4
      return this.bgColors[index]
    },
    renderPicture: function (path) {
      return !path ? 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png' : path
    },
    truncateText: function (text, length) {
      if (text.length <= length) return text

      return text.substring(0, length) + '...'
    },
    updateSelectedTopic: function (card) {
      var parentName = this.subject.nama
      var parentId = this.subject.id

      if (this.topic) {
        parentId = this.topic.id
        parentName = this.topic.nama
      }

      if (this.subTopic) {
        parentId = this.subTopic.id
        parentName = this.subTopic.nama
      }

      var selectedTopic = {
        id: card.id,
        parentId: parentId,
        parentName: parentName,
        name: card.nama,
        code: card.kode
      }

      this.selectedTopic = selectedTopic
    },
    showDetail: function (card) {
      this.updateSelectedTopic(card)
      this.showModal = true
    },
    showDeleteConfirmation: function (card) {
      this.updateSelectedTopic(card)
      this.showConfirmationModal = true
    },
    updateTopic: function () {
      if (this.selectedTopic.name.length === 0) {
        this.errors = {formTopicName: 'Field nama harus diisi'}
        return
      }

      if (this.subTopic) this.doUpdateSubSubBab()
      else if (this.topic) this.doUpdateSubBab()
      else this.doUpdateBab()
    },
    doUpdateBab: function () {
      var data = {
        mapel_id: this.subject.id,
        name: this.selectedTopic.name
      }

      var context = this
      var babId = this.selectedTopic.id
      this.isLoading = true

      ItembankService.updateBab(babId, data, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === babId
          })

          var card = context.cards[index]
          card.nama = response.data.nama

          context.$set(context.cards, index, card)
          context.isLoading = false
          context.showModal = false
        }
      })
    },
    doUpdateSubBab: function () {
      var data = {
        bab_id: this.selectedTopic.parentId,
        name: this.selectedTopic.name
      }

      var context = this
      var id = this.selectedTopic.id
      this.isLoading = true

      ItembankService.updateSubBab(id, data, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id
          })

          var card = context.cards[index]
          card.nama = response.data.nama

          context.$set(context.cards, index, card)
          context.isLoading = false
          context.showModal = false
        }
      })
    },
    doUpdateSubSubBab: function () {
      var data = {
        subbab_id: this.selectedTopic.parentId,
        name: this.selectedTopic.name
      }

      var context = this
      var id = this.selectedTopic.id
      this.isLoading = true

      ItembankService.updateSubSubBab(id, data, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id
          })

          var card = context.cards[index]
          card.nama = response.data.nama

          context.$set(context.cards, index, card)
          context.isLoading = false
          context.showModal = false
        }
      })
    },
    deleteTopic: function () {
      if (this.subTopic) this.doDeleteSubSubBab()
      else if (this.topic) this.doDeleteSubBab()
      else this.doDeleteBab()
    },
    doDeleteBab: function () {
      var context = this
      var id = this.selectedTopic.id
      this.isLoading = true

      ItembankService.deleteBab(id, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id
          })

          context.$delete(context.cards, index)
        } else {
          context.$store.commit('error_show', 'Tidak dapat menghapus bab, pastikan bab tidak termapping dengan soal')
        }

        context.showConfirmationModal = false
        context.isLoading = false
      })
    },
    doDeleteSubBab: function () {
      var context = this
      var id = this.selectedTopic.id
      this.isLoading = true

      ItembankService.deleteSubBab(id, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id
          })

          context.$delete(context.cards, index)
        } else {
          context.$store.commit('error_show', 'Tidak dapat menghapus bab, pastikan bab tidak termapping dengan soal')
        }

        context.showConfirmationModal = false
        context.isLoading = false
      })
    },
    doDeleteSubSubBab: function () {
      var context = this
      var id = this.selectedTopic.id
      this.isLoading = true

      ItembankService.deleteSubSubBab(id, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id
          })

          context.$delete(context.cards, index)
        } else {
          context.$store.commit('error_show', 'Tidak dapat menghapus bab, pastikan bab tidak termapping dengan soal')
        }

        context.showConfirmationModal = false
        context.isLoading = false
      })
    },
    addNewTopic: function () {
      if (this.formTopicName === '') {
        this.errors = {formTopicName: 'Field nama harus diisi'}
        return false;
      }

      if (this.subTopic) this.doAddSubSubBab()
      else if (this.topic) this.doAddSubBab()
      else this.doAddBab()
    },
    doAddBab: function () {
      var data = {
        mapel_id: this.subject.id,
        name: this.formTopicName
      }

      var context = this
      this.isLoading = true
      ItembankService.addBab(data, function (response) {
        if (response.success) {
          var card = {
            id: response.data.id,
            nama: response.data.nama,
            kode: response.data.kode
          }

          context.cards.push(card)
          context.formTopicName = ''
          context.isLoading = false
          context.showNewTopicDialog = false
        }
      })
    },
    doAddSubBab: function () {
      var data = {
        bab_id: this.topic.id,
        name: this.formTopicName
      }

      var context = this
      this.isLoading = true
      ItembankService.addSubBab(data, function (response) {
        if (response.success) {
          var card = {
            id: response.data.id,
            nama: response.data.nama,
            kode: response.data.kode
          }

          context.cards.push(card)
          context.formTopicName = ''
          context.isLoading = false
          context.showNewTopicDialog = false
        }
      })
    },
    doAddSubSubBab: function () {
      var data = {
        subbab_id: this.subTopic.id,
        name: this.formTopicName
      }

      var context = this
      this.isLoading = true
      ItembankService.addSubSubBab(data, function (response) {
        if (response.success) {
          var card = {
            id: response.data.id,
            nama: response.data.nama,
            kode: response.data.kode
          }

          context.cards.push(card)
          context.formTopicName = ''
          context.isLoading = false
          context.showNewTopicDialog = false
        }
      })
    }
  },
  beforeMount: function() {
    var subjectId = this.$route.query.subject_id
    var subjects = JSON.parse(window.localStorage.getItem('mapels'))
    var found = subjects.find(function (subject) {
      return subject.id === subjectId
    })

    this.subject = found
  },
  mounted: function () {
    var context = this
    ItembankService.getListOfTopic(this.subject.code, function (response) {
      if (response.success) {
        response.data.forEach(function (topic) {
          context.topics.push(topic)
        })

        context.cards = context.topics
        context.filteredCards = context.cards
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// TopicManagementDetail.vue?7f0a8142